import { render, staticRenderFns } from "./updatepwd.vue?vue&type=template&id=7423c3e0&scoped=true"
import script from "./updatepwd.vue?vue&type=script&lang=js"
export * from "./updatepwd.vue?vue&type=script&lang=js"
import style0 from "./updatepwd.vue?vue&type=style&index=0&id=7423c3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7423c3e0",
  null
  
)

export default component.exports